import React, { Component, useRef, useEffect } from 'react'
import { Toast, DotLoading, Mask } from 'antd-mobile'
import qs from 'qs'
// import qs13 from '../static/media/qs13.png';
import snow from '../../static/media/snow.gif'
import TestResult from './result'
import FriendResult from './friend'
import NewForm from './NewForm'
import friendrst from '../../static/media/friendrst.png'
import friendrst2 from '../../static/media/friendrst2.png'
import { personalityResult } from './const'

class Questions extends Component {
  state = {
    topFourTypes: '',
    options: [
      {
        A: '一月3-5位',
        B: '半年3-5位',
        select: '',
      },
      {
        A: '不是，我更喜欢电话沟通更真实和高效',
        B: '是的，除非紧急事务，我更倾向于线上文字沟通',
        select: '',
      },
      {
        A: '与许多不同的人交流，参与各种话题和活动',
        B: '与一两个亲密的朋友进行深入的对话和交流',
        select: '',
      },
      {
        A: '花很多时间，确保内容和排版都尽善尽美',
        B: '更注重内容和效率，排版看得过去就行',
        select: '',
      },
      {
        A: '稳定和可靠的工作环境，喜欢按照既定的规则和程序进行工作',
        B: '具有创意和变化的工作环境，喜欢面对新的挑战和机会',
        select: '',
      },
      {
        A: '参加徒步、登山等户外运动、进行陶瓷、园艺等手工制作',
        B: '参加阅读会、参观艺术展、聆听音乐会',
        select: '',
      },
      {
        A: '以客观的态度接受批评，分析批评的合理性并进行改进',
        B: '受到批评时感到情绪上的冲击，关注他人对错误的看法和感受',
        select: '',
      },
      {
        A: '考虑长期的利益和目标，做出理性和有利于未来发展的决策',
        B: '考虑个人的情感和内心的追求，追随直觉和内在的欲望做出决策',
        select: '',
      },
      {
        A: '分析和解决问题，逐步完成任务来减轻压力',
        B: '寻求情感支持和情绪释放，注重自身情感状态的平衡',
        select: '',
      },
      {
        A: '是的。我总隐隐担心，不停打听进展，很没有安全感',
        B: '不会担心。我做好了自己分内的工作，事情的发展也不是我能决定的',
        select: '',
      },
      {
        A: '去常吃的馆子，根据自己的口味偏好选择常吃的那几样菜',
        B: '寻找一家新餐厅，选择餐厅主推的菜品，尝试新的味道和体验',
        select: '',
      },
      {
        A: '仔细研究和比较不同商家的同一样物品的区别和优劣',
        B: '随意挑一挑，凭直觉和感觉快速做出购买决策',
        select: '',
      },
    ],
  }

  imagesRefs = []

  constructor(props) {
    super(props)
    for (let i = 0; i < 13; i++) {
      this.imagesRefs[i] = React.createRef()
    }
  }

  handleSubmit = (data) => {
    const params = qs.parse(window.location.href.split('?')[1])
    const { userInfo } = this.props
    let notSelectIndex = null
    this.state.options.filter((item, index) => {
      if (notSelectIndex === null && !item.select) {
        notSelectIndex = index
      }
    })
    if (notSelectIndex === null) {
      const result = this.calculatePersonalityType()
      console.log('Personality Type:', {
        ...data,
        testResult: result,
      })
      if (!data.nickName && !data.nickName.trim()) {
        data.nickName = userInfo.nickname
      }
      data.nickName = encodeURIComponent(userInfo.nickname)
      fetch(`//home-service.chinanestor.com/openAPI/activity/submitTestResult`, {
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
        },
        body: JSON.stringify({
          ...data,
          testResult: result,
          headPortrait: userInfo.headImgUrl,
          sharer: params.shareId !== userInfo.openId ? params.shareId || '' : '',
          submitter: userInfo.openId,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          // 更新 MyMBTI 组件的状态，显示结果页面
          this.setState({ answerState: true }, () => {
            this.props.showResult(result, data.nickName) // Pass 'result' (topFourTypes) to showResult
          })
        })
    } else {
      Toast.show({
        content: '请选择完所有问题再提交哦',
      })
      this.imagesRefs[notSelectIndex + 1].current.scrollIntoView({
        behavior: 'smooth',
      })
    }
  }

  handleMyButtonClick = (index, type) => {
    // 如果是第一个按钮（开始答题），只执行滑动逻辑
    if (type === 'start') {
      this.imagesRefs[1].current.scrollIntoView({ behavior: 'smooth' })
      return
    }

    const _options = [...this.state.options]
    _options[index - 1].select = type

    this.setState(
      {
        options: _options,
      },
      () => {
        let notSelectIndex = null
        this.state.options.filter((item, index) => {
          if (notSelectIndex === null && !item.select) {
            notSelectIndex = index
          }
        })
        if (notSelectIndex === null) {
          window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'smooth',
          })
        } else {
          this.imagesRefs[notSelectIndex + 1].current.scrollIntoView({
            behavior: 'smooth',
          })
        }
      }
    )

    // const result = this.calculatePersonalityType(newAnswers);
    // console.log('Personality Type:', result);
  }

  // Method to scroll to the second image
  scrollToSecondImage = () => {
    // Use scrollIntoView to scroll to the second image
    if (this.imagesRefs[1] && this.imagesRefs[1].current) {
      this.imagesRefs[1].current.scrollIntoView({ behavior: 'smooth' })
    }
  }

  calculatePersonalityType = () => {
    const typeScores = {
      E: 0,
      I: 0,
      S: 0,
      N: 0,
      T: 0,
      F: 0,
      J: 0,
      P: 0,
    }

    this.state.options.forEach((item, index) => {
      if (index < 3) {
        typeScores[item.select === 'A' ? 'E' : 'I']++
      } else if (index < 6) {
        typeScores[item.select === 'A' ? 'S' : 'N']++
      } else if (index < 9) {
        typeScores[item.select === 'A' ? 'T' : 'F']++
      } else {
        typeScores[item.select === 'A' ? 'J' : 'P']++
      }
    })
    // Convert typeScores object to an array of objects
    const typeScoresArray = Object.entries(typeScores).map(([type, score]) => ({
      type,
      score,
    }))

    // Sort the array based on scores in descending order
    typeScoresArray.sort((a, b) => b.score - a.score)
    // Get the top four personality types
    const topFourTypes = typeScoresArray.slice(0, 4).map((entry) => entry.type)

    // Sort the array based on the predefined order: E I S N T F J P
    const orderedTypes = ['E', 'I', 'S', 'N', 'T', 'F', 'J', 'P']
    const sortedTopFourTypes = topFourTypes.sort(
      (a, b) => orderedTypes.indexOf(a) - orderedTypes.indexOf(b)
    )

    console.log('sortedTopFourTypes', sortedTopFourTypes.join(''))

    const newtopFourTypes = sortedTopFourTypes.join('')

    this.setState({ topFourTypes: newtopFourTypes })
    return newtopFourTypes
  }

  render() {
    const { options } = this.state
    const { userInfo } = this.props

    // 否则，渲染问题页面
    return (
      <div>
        {this.imagesRefs.map((ref, index) => (
          <div key={index} className="imageContainer">
            <img src={snow} className="snowflake" alt="" />
            <img ref={ref} src={require(`/src/static/media/qs${index}.jpg`)} alt="" />
            {index === 0 ? (
              <>
                <button className="rankBtn" onClick={this.props.showFriendResult}>
                  好友测试结果
                </button>
                <button
                  className="startButton"
                  onClick={() => this.handleMyButtonClick(index, 'start')}
                >
                  开始
                  <br />
                  答题
                  <br />{' '}
                  <span style={{ fontSize: 10, textAlign: 'center', margin: 0 }}>
                    本测试由值得信赖的仓储及工业设施租售专家的瑞莱博出品
                  </span>
                </button>
              </>
            ) : (
              <>
                <button
                  id={`button${index}A`}
                  className={`overlayButtonBTN1 ${
                    options[index - 1].select === 'A' ? 'selected btnSelected1' : ''
                  } leftAlignedText`}
                  onClick={() => this.handleMyButtonClick(index, 'A')}
                >
                  {options[index - 1]['A']}
                </button>
                <button
                  id={`button${index}B`}
                  className={`overlayButtonBTN2 ${
                    options[index - 1].select === 'B' ? 'selected btnSelected2' : ''
                  } leftAlignedText`}
                  onClick={() => this.handleMyButtonClick(index, 'B')}
                >
                  {options[index - 1]['B']}
                </button>
              </>
            )}
          </div>
        ))}
        {/* 添加最后一张图，包含昵称输入框和提交按钮 */}
        <div className="imageContainer">
          <img src={friendrst} alt="" />
          <NewForm userInfo={userInfo} onSubmit={this.handleSubmit} />
          <img src={friendrst2} alt="" />
        </div>
      </div>
    )
  }
}

const AudioBgm = () => {
  const audioRef = useRef(null)

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = 0.35 // Set the volume here
      document.addEventListener(
        'WeixinJSBridgeReady',
        function () {
          audioRef.current.play().catch((error) => {
            console.error('Autoplay error:', error)
          })
        },
        false
      )
      // audioRef.current.play().catch((error) => {
      //   console.error('Autoplay error:', error);
      // });
    }
  }, [audioRef.current])

  return (
    <>
      <audio ref={audioRef} autoPlay loop>
        <source src="../../static/bgm.mp3" type="audio/mp3" />
      </audio>
    </>
  )
}
let timer = null
class MyMBTI extends Component {
  state = {
    showResult: false,
    showFriendResult: false,
    topFourTypes: '',
    friendTestResultListInfoList: [],
    nickname: '',
    participated: false, // 是否参与
    reloadFlag: 1, // 1: 未答题  2：已答题
    userInfo: {
      nickname: '',
      headImgUrl: '',
      openId: '',
    },
    // 控制是否显示结果页面
  }

  componentDidMount() {
    // document.title = "测测你的动物MBTI";
    document.title = '瑞莱博2023年物流地产年度报告'
    const params = qs.parse(window.location.href.split('?')[1])
    if (!params.code) {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxc005ab723cf1e525&redirect_uri=${encodeURIComponent(
        window.location.href.split('#')[0]
      )}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
      window.addEventListener('visibilitychange', this.handleWindowStateChange)
    } else {
      // this.getWxConfig();
      this.getUserInfo(params.code)
      document.body.addEventListener('touchstart', this.audioAutoPlay)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('visibilitychange', this.handleWindowStateChange)
    document.body.removeEventListener('touchstart', this.audioAutoPlay)
  }

  audioAutoPlay = () => {
    var audio = document.getElementById('palyBgm')
    audio.volume = 0.35
    audio.play()
    document.body.removeEventListener('touchstart', this.audioAutoPlay)
  }

  handleWindowStateChange = () => {
    // 判断当前窗口是否为活动状态
    if (document.hidden) {
      // alert("当前窗口不活跃");
    } else {
      this.setState({
        showFriendResult: false,
        topFourTypes: '',
      })
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxc005ab723cf1e525&redirect_uri=${encodeURIComponent(
        window.location.href.split('#')[0]
      )}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
    }
  }

  getUserInfo = (code) => {
    fetch(`//home-service.chinanestor.com/openAPI/wms/wx/page/userInfo?code=${code}`)
      .then((res) => res.json())
      .then((res) => {
        this.setState(
          {
            userInfo: res,
          },
          () => {
            const params = qs.parse(window.location.href.split('?')[1])
            if (params.shareId && params.shareId !== res.openId) {
              this.activityRelationBind(
                {
                  submitter: res.openId,
                  sharer: params.shareId,
                },
                () => {
                  this.getResultInfo(() => {
                    this.getWxConfig()
                  })
                }
              )
            } else {
              this.getResultInfo(() => {
                this.getWxConfig()
              })
            }
          }
        )
      })
      .catch((err) => console.log(err))
  }

  getResultInfo = (callback) => {
    const { userInfo } = this.state
    fetch(`//home-service.chinanestor.com/openAPI/activity/testResultListInfo`, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
      },
      body: JSON.stringify({
        submitter: userInfo.openId,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        const { testResult, friendTestResultListInfoList, nickName, reloadFlag } = res.data || {}
        const params = qs.parse(window.location.href.split('?')[1])
        this.setState(
          {
            topFourTypes: testResult || '',
            friendTestResultListInfoList: friendTestResultListInfoList || [],
            nickName,
            reloadFlag,
            participated: !!nickName,
          },
          () => {
            callback && callback()
          }
        )
      })
  }

  activityRelationBind = (obj, callback) => {
    fetch(`//home-service.chinanestor.com/openAPI/activity/relationBind`, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
      },
      body: JSON.stringify(obj),
    })
      .then((res) => res.json())
      .then((res) => {
        callback && callback()
      })
      .catch(() => {
        callback && callback()
      })
  }

  getWxConfig = () => {
    fetch(
      `//home-service.chinanestor.com/openAPI/wms/wx/jsConfig?url=${encodeURIComponent(
        window.location.href.split('#')[0]
      )}`
    )
      .then((res) => res.json())
      .then((res) => {
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          // appId: res.appId,
          // timestamp: +res.timestamp,
          // nonceStr: res.nonceStr,
          // signature: res.signature,
          ...res,
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 必填，需要使用的JS接口列表
        })
        window.wx.ready(() => {
          // window.wx.hideMenuItems({
          //   menuList: [
          //     'menuItem:share:qq',
          //     'menuItem:share:weiboApp',
          //     'menuItem:share:facebook',
          //     'menuItem:share:QZone',
          //     'menuItem:openWithSafari',
          //     'menuItem:openWithQQBrowser',
          //     'menuItem:originPage',
          //     'menuItem:share:email'
          //   ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
          // });
          this.shareConfig()
          const params = qs.parse(window.location.href.split('?')[1])
          if (params.shareId) {
            window.history.replaceState(
              {},
              0,
              window.location.href.split('?')[0] + `?shareId=${params.shareId}`
            )
          } else {
            window.history.replaceState({}, 0, window.location.href.split('?')[0])
          }
        })
      })
      .catch((err) => console.log(err))
  }

  // 分享配置
  shareConfig = () => {
    const { topFourTypes, userInfo } = this.state
    const config = {
      title: '注意！MBTI题库已更新，一分钟速测版，准到发麻！',
      desc: `赶紧测一下，看看我是不是你的贵人哟？好多人都说超准的！`,
      link: `${window.location.href.split('?')[0]}?shareId=${userInfo.openId}`,
      imgUrl: userInfo.headImgUrl,
    }
    // 有测试结果的
    if (topFourTypes) {
      personalityResult.filter((item) => {
        if (item.type === topFourTypes) {
          config.title = `一觉睡醒变成${topFourTypes}了，60秒测出你的最新人格！`
          config.desc = '你们是什么类型？快来测一下吧，看我旺不旺你？！'
          config.imgUrl = `https://activity.ixuanzhi.com/static/result/${topFourTypes}.png`
        }
      })
    }
    // 分享朋友
    window.wx.updateAppMessageShareData({
      ...config,
      success: () => {
        // 设置成功
      },
      fail: () => {
        // 设置成功
      },
    })
    // 朋友圈
    window.wx.updateTimelineShareData({
      ...config,
      success: () => {
        // 设置成功
      },
      fail: () => {
        // 设置成功
      },
    })
  }

  questionsRef = React.createRef()

  goBackToQuestions = () => {
    // Update state to hide FriendResult and show Questions
    this.setState({ showFriendResult: false }, () => {
      // Scroll to the second image after state update
      this.getResultInfo(() => {
        timer && clearTimeout(timer)
        timer = setTimeout(() => {
          if (this.questionsRef.current) {
            this.questionsRef.current.scrollToSecondImage()
          }
        }, 500)
      })
    })
  }

  // 切换 showResult 状态，显示结果页面
  showResult = (topFourTypes, nickname) => {
    console.log('showResult' + topFourTypes, nickname)
    this.setState({ topFourTypes, reloadFlag: 2, nickname }, () => {
      window.scrollTo(0, 0)
      this.shareConfig()
    })
  }

  showFriendResult = () => {
    this.setState({ showFriendResult: true }, () => {
      this.getResultInfo()
    })
  }

  render() {
    console.log('MyMBTI State:', this.state)
    return (
      <div>
        <audio id="palyBgm" src={require('../../static/media/bgm.mp3')} loop="loop" />
        {this.state.showFriendResult ? (
          <FriendResult
            reloadFlag={this.state.reloadFlag}
            participated={this.state.participated}
            topFourTypes={this.state.topFourTypes}
            nickname={this.state.nickname}
            friendTestResultListInfoList={this.state.friendTestResultListInfoList}
            goBackToQuestions={this.goBackToQuestions}
            goBack={() => {
              this.setState(
                {
                  showFriendResult: false,
                },
                () => {
                  window.scrollTo(0, 0)
                }
              )
            }}
          />
        ) : this.state.topFourTypes && this.state.reloadFlag === 2 ? (
          <TestResult
            topFourTypes={this.state.topFourTypes}
            nickname={this.state.nickname}
            userInfo={this.state.userInfo}
            goBackToQuestions={this.goBackToQuestions}
            lookFriend={() => {
              this.getResultInfo(() => {
                this.setState(
                  {
                    showFriendResult: true,
                  },
                  () => {
                    window.scrollTo(0, 0)
                  }
                )
              })
            }}
          />
        ) : (
          <Questions
            ref={this.questionsRef}
            userInfo={this.state.userInfo}
            resultVisible={this.state.showResult}
            showResult={this.showResult}
            showFriendResult={this.showFriendResult} // Pass the function as a prop
            showTestResult={this.showTestResult}
            setNickname={(nickname) => this.setState({ nickname })}
            setAnswerState={(answerState) => this.setState({ answerState })}
            topFourTypes={this.state.topFourTypes}
          />
        )}
        {!this.state.userInfo.openId && (
          <Mask opacity="thick" visible={true}>
            <div
              style={{
                width: '100vw',
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
              }}
            >
              <DotLoading color="#ffffff" />
              <span style={{ color: '#ffffff' }}>正在授权中</span>
            </div>
          </Mask>
        )}
      </div>
    )
  }
}

export default MyMBTI
